import React from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"
// import { useStaticQuery, graphql } from "gatsby"




import loadable from '@loadable/component'

const Button = loadable(() => import("./basic-components/button"))


const Signup = ({title, description, label, buttonLabel, sectionStyle="white"}) => {


    const newsletterSubscribe = event =>{

        var form = document.getElementById("sign-up-newsletter-form")
        // console.log(form.elements["branchmessage-enquiry-type"].value) //returns selected radio option
        // console.log(form)
    
    
        var cform = {
            Action: "newsletter-form",
            Email: form.elements["newsletter-subscribe-email"].value,
        }
    
        // console.log(cform)
    
      
        var submitBtn = document.getElementById("signUpNewsletter").firstChild;
        submitBtn.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="spinner" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"></path></svg>';
        submitBtn.classList.add("form-submitting");
      
        var body = {
          Token: process.env.GATSBY_SUBSCRIBE_TOKEN,
          FormData: JSON.stringify(cform)   
        };
      
      
        addToMailchimp(form.elements["newsletter-subscribe-email"].value)
          .then(response =>{

              if(response.result === 'success'){
                submitBtn.innerHTML = "Subscribed! Thank you"
                submitBtn.classList.remove("form-submitting")
              }else{
                submitBtn.innerHTML = "Oops... Try again later!"
                submitBtn.classList.remove("form-submitting")
              }
          })
          
        // console.log("Message sent");
      
        event.preventDefault();
      }

    const sectionClassName = sectionStyle =="white" ? "white-section" : "dark-section";


    return (
    <section className={sectionClassName + " signup-section padding-top padding-bottom lateral-padding"}>
        <div className="uk-text-center">
            <div className="section-content">
                <h2 >{title}</h2>
                <div className="section-subtitle ">{description}</div>
                <form id="sign-up-newsletter-form" onSubmit={newsletterSubscribe}>
                    <div className="signup-container">
                        <input id="newsletter-subscribe-email" type="email" placeholder="email address"/>
                        <div id="signUpNewsletter">
                          {/* <Button use="" label="Sign Up"></Button> */}
                          <button className=".btn">Sign Up</button>  
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
    )

       
    
}

export default Signup